/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryAssessmentAgentReportType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryAssessmentAgentReportType");
    }

    getFixupPrototypeFunction() { return ScheduleQueryAssessmentAgentReportType.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryAssessmentAgentReportType>): ScheduleQueryAssessmentAgentReportType {
        let obj = Object.assign(new ScheduleQueryAssessmentAgentReportType(), model);
        ScheduleQueryAssessmentAgentReportType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryAssessmentAgentReportType>): ScheduleQueryAssessmentAgentReportType {
        if (!model) return null;
        return ScheduleQueryAssessmentAgentReportType.newInstance(<ScheduleQueryAssessmentAgentReportType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryAssessmentAgentReportType) {
        if (!obj) return;

        models.ScheduleQueryAssessmentAgentReportType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryAssessmentAgentReportType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryAssessmentAgentReportType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Ai Assessment Agent Report Type of the Schedule for category reports
     */
    assessment_agent_report_types: Array<models.AiAgenticFeedReportType>;

}
